(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const bnplWrapper = document.querySelector('.buy-now-pay-later-wrapper');
    if (!bnplWrapper) return;

    const toggleButton = bnplWrapper.querySelector('.bnpl-toggle-button');
    const detailsSection = bnplWrapper.querySelector('.buy-now-pay-later-details');
    const plusIcon = toggleButton.querySelector('.plus-icon');
    const installmentMessage = bnplWrapper.querySelector('.installment-message');

    if (!toggleButton || !detailsSection || !plusIcon || !installmentMessage) return;

    // Function to extract the numerical value from a money string
    function getNumericPrice(moneyString) {
      return parseFloat(moneyString.replace(/[^\d.]/g, ''));
    }

    // Function to find the smallest monthly payment
    function findSmallestMonthlyPayment() {
      const mobicredAmountSpan = detailsSection.querySelector('.mobicred-amount');
      const rcsAmountSpan = detailsSection.querySelector('.rcs-amount');
      const zeropayAmountSpan = detailsSection.querySelector('.zeropay-amount');
      const floatAmountSpan = detailsSection.querySelector('.my-multiplier:nth-child(2)'); // Targeting the amount for Float

      let smallest = Infinity;

      if (mobicredAmountSpan) {
        smallest = Math.min(smallest, getNumericPrice(mobicredAmountSpan.textContent));
      }
      if (rcsAmountSpan) {
        smallest = Math.min(smallest, getNumericPrice(rcsAmountSpan.textContent));
      }
      if (zeropayAmountSpan) {
        smallest = Math.min(smallest, getNumericPrice(zeropayAmountSpan.textContent));
      }
      // Directly target the second .my-multiplier in the Float <li>
      const floatLi = Array.from(detailsSection.querySelectorAll('li')).find(li => li.innerHTML.includes('Float'));
      if (floatLi) {
        const floatAmountElement = floatLi.querySelector('.my-multiplier:nth-child(2)');
        if (floatAmountElement) {
          smallest = Math.min(smallest, getNumericPrice(floatAmountElement.textContent));
        }
      }

      return smallest === Infinity ? null : smallest.toFixed(2);
    }

    // Set the initial installment message
    const smallestPayment = findSmallestMonthlyPayment();
    if (smallestPayment) {
      installmentMessage.textContent = `From R${smallestPayment} per month`;
    } else {
      installmentMessage.textContent = 'Easy installment options available:'; // Fallback
    }

    toggleButton.addEventListener('click', function() {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
      detailsSection.hidden = isExpanded;
      toggleButton.setAttribute('aria-expanded', !isExpanded);

      if (isExpanded) {
        plusIcon.textContent = '+';
        plusIcon.classList.remove('minus-icon');
        plusIcon.classList.add('plus-icon');
      } else {
        plusIcon.textContent = '−';
        plusIcon.classList.remove('plus-icon');
        plusIcon.classList.add('minus-icon');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-video-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const texts = document.querySelectorAll('.text-overlay div');
    const videoBanner = document.querySelector('.video-banner');
    const button = document.getElementById('video-banner-btn');
    let currentIndex = 0;
    const interval = parseInt(videoBanner.getAttribute('data-text-display-duration')) || 3000; // Text display duration from the data attribute
    const pause = parseInt(videoBanner.getAttribute('data-pause-duration')) || 12000; // Pause duration from the data attribute
    const initialDelay = parseInt(videoBanner.getAttribute('data-initial-delay')) || 0; // Initial delay from the data attribute

    // Handle button scroll behavior
    button.addEventListener('click', function(event) {
      const btnUrl = button.getAttribute('href');
      if (!btnUrl || btnUrl === '#') {
        event.preventDefault(); // Prevent default link behavior
        const targetSection = document.querySelector('.why-use-float-clarity-bnpy'); // Target the product-grid-container class
        if (targetSection) {
          targetSection.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    });

    function showNextText() {
      texts.forEach((text, index) => {
        text.style.opacity = (index === currentIndex) ? '1' : '0';
      });
      currentIndex = (currentIndex + 1) % texts.length;

      if (currentIndex === 0) {
        clearInterval(textInterval);
        setTimeout(() => {
          texts.forEach(text => text.style.opacity = '0');
          setTimeout(() => {
            textInterval = setInterval(showNextText, interval);
          }, pause);
        }, interval);
      }
    }

    // Show the first text after the initial delay
    setTimeout(() => {
      if (texts.length > 0) {
        texts[0].style.opacity = '1';
      }
      // Start the interval for subsequent animations
      textInterval = setInterval(showNextText, interval);
    }, initialDelay);
  });

  } catch(e) { console.error(e); }
})();
})();
